import { useCallback, useState, type ReactNode } from 'react';

export interface TooltipState {
  x: number;
  y: number;
  content: ReactNode;
}

/**
 * Tooltipen renderas i fixed position mot muspekaren och vänder sida när den
 * skulle hamna utanför fönstret.
 */
export function useTooltip() {
  const [tooltip, setTooltip] = useState<TooltipState | null>(null);

  const show = useCallback((event: { clientX: number; clientY: number }, content: ReactNode) => {
    setTooltip({ x: event.clientX, y: event.clientY, content });
  }, []);

  const hide = useCallback(() => setTooltip(null), []);

  return { tooltip, show, hide };
}

export function TooltipLayer({ tooltip }: { tooltip: TooltipState | null }) {
  if (!tooltip) return null;

  const flipX = tooltip.x > window.innerWidth - 320;
  const flipY = tooltip.y > window.innerHeight - 200;

  return (
    <div
      className="tooltip"
      role="tooltip"
      style={{
        left: flipX ? undefined : tooltip.x + 14,
        right: flipX ? window.innerWidth - tooltip.x + 14 : undefined,
        top: flipY ? undefined : tooltip.y + 14,
        bottom: flipY ? window.innerHeight - tooltip.y + 14 : undefined,
      }}
    >
      {tooltip.content}
    </div>
  );
}

export function TooltipRow({ color, label, value }: { color?: string; label: string; value: ReactNode }) {
  return (
    <div className="tooltip__row">
      {color ? <span className="legend__swatch" style={{ background: color }} aria-hidden="true" /> : null}
      <span>{label}</span>
      <strong>{value}</strong>
    </div>
  );
}
